"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasmTx = void 0;
const terra_js_1 = require("@terra-money/terra.js");
class WasmTx {
    constructor(querier, sender, messages, memo) {
        this.querier = querier;
        this.sender = sender;
        this.messages = messages;
        this.memo = memo;
    }
    get tax() {
        return this.querier.getTax();
    }
    get tx() {
        return this._tx;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this._tx = yield this.querier.estimateFee(this.sender, this.messages, this.memo, this.feeDenom ? [this.feeDenom] : undefined);
        });
    }
    getTotalAmount() {
        return this.getMsgs().map(msg => {
            for (const key in msg) {
                if (msg[key] === undefined)
                    continue;
                if (msg[key] instanceof terra_js_1.Coins) {
                    const coins = msg[key];
                    if (coins.denoms().length > 0)
                        return coins;
                }
                if (msg[key] instanceof terra_js_1.Coin)
                    return new terra_js_1.Coins([msg[key]]);
            }
            return new terra_js_1.Coins();
        }).reduce((prev, curr) => prev.add(curr));
    }
    getTotalFee() {
        var _a;
        return (_a = this.tx.fee.amount) !== null && _a !== void 0 ? _a : new terra_js_1.Coins();
    }
    getTotalTax() {
        return this.getTotalAmount().mul(this.tax);
    }
    getMsgs() {
        return this.messages.map(e => e.msg);
    }
    getTxOptions(feeDenom) {
        return __awaiter(this, void 0, void 0, function* () {
            this.feeDenom = feeDenom;
            yield this.init();
            const coins = this.tx.fee.amount.add(this.getTotalTax());
            const fee = new terra_js_1.Fee(this.tx.fee.gas_limit, coins.map(e => new terra_js_1.Coin(e.denom, Number(e.amount).toFixed(0))));
            const tx = Object.assign(Object.assign({}, this.tx), { fee });
            return tx;
        });
    }
}
exports.WasmTx = WasmTx;
